import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/forumbee': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M5.8 309.7c-3.8-17-5.8-34.2-5.8-51.4 0-123.3 99.8-223.3 223.1-223.3 16.6 0 33.3 2 49.3 5.5-123.4 47-220.5 145.5-266.6 269.2zM398.7 120.5c-151.1 44-269.2 164.4-312.3 315.7-17.2-13.4-32.7-30.9-45.2-49 43.4-149.9 160.1-267.7 309.7-312 18.1 12.6 34.1 27.8 47.8 45.3zM414.5 373.2c13.1 35.3 24.2 73.3 33.5 109.8-36.1-9.3-72-20.5-107-33.6-25.7 16-54.6 26.9-84.6 31.3 42.6-79.7 108.2-147.4 187.6-190.3-4.1 29.1-14.3 57.7-29.5 82.8zM444.2 227.7c-113.7 46.7-204.2 139.4-250.5 253.5-19.6-2.7-38.5-7.6-56.6-15.2 44.9-138.5 153.4-249.3 291.3-295.1 7.9 18.1 13.2 37.3 15.8 56.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/forumbee.js
// module id = 841
// module chunks = 0